import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-link',
    templateUrl: './link.component.html',
    styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit {

    @Input() icon = '';
    @Input() text = '';
    @Input() payload: any;


    @Output() clicked = new EventEmitter<any>();


    @HostListener('click', ['$event.target'])
    onBatchClick() {
        this.clicked.emit(this.payload);
    }

    constructor() {
    }

    ngOnInit() {
    }

}
